<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    // 初始化应用状态
    this.$store.dispatch('initApp')
  }
}
</script>

<style lang="less">
#app {
  height: 100%;
}
* {
  box-sizing: border-box;
}
.el-tabs__item {
  line-height: 28px !important;
  height: 28px !important;
}
.el-tabs__header {
  margin-bottom: 4px !important;
}

.v-modal {
  opacity: 0.05 !important;
}

.el-tabs--card > .el-tabs__header .el-tabs__nav .is-active {
  background-color: #c4edff !important;
  color: #333 !important;
}
</style>
